import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../stores/useAuthStore';
import Avatar from '../../uikit/avatar';

export default function GroupNotificationToast({ message }) {
  const navigate = useNavigate();
  const user = useAuthStore((state) => state.user);

  const handleClick = () => {
    navigate(`/message/groups/${message.chatGroupId}/${user.uid}`);
  };

  const groupName = message.groupName || 'Unknown Group';
  const senderName = message.senderName || 'Unknown User';

  return (
    <div
      className="flex items-start max-w-sm p-3 mx-auto space-x-3 text-white bg-black rounded-lg shadow-md bg-opacity-20 backdrop-blur-md w-80 cursor-pointer"
      onClick={handleClick}
    >
      <div className="flex-shrink-0 mt-1">
        <Avatar
          text={groupName}
          textSize={18}
          imageUrl={message.groupImage || ''}
        />
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex flex-col space-y-1">
          <h3 className="text-lg font-semibold text-white truncate">
            {groupName}
          </h3>
          <p className="text-sm text-gray-100 truncate">From: {senderName}</p>
        </div>
        <p className="mt-2 text-base text-white line-clamp-2 leading-relaxed">
          {message.textMessage}
        </p>
      </div>
    </div>
  );
}

GroupNotificationToast.propTypes = {
  message: PropTypes.shape({
    chatGroupId: PropTypes.string.isRequired,
    senderName: PropTypes.string,
    groupName: PropTypes.string,
    groupImage: PropTypes.string,
    textMessage: PropTypes.string.isRequired,
  }).isRequired,
};
